import React, { FC } from "react";
import { darkTheme } from "@yleisradio/yds-core";
import { ArrowRight } from "@yleisradio/yds-icons-react";
import styled from "styled-components";

import { useEmbedParametersContext } from "../../contexts/EmbedParametersContext";
import { UI_SIZE } from "../../enums";
import { getAreenaUrl } from "../../helpers/areenaLinks";
import i18n from "../../service/i18n";
import { usePlayerStore } from "../../store/usePlayerStore";
import {
  OverlayButtonWrapper,
  overlayLinkOrButtonStyle,
  shareButtonStyle,
  textButtonStyle
} from "../VideoOverlayButton";

const NotAllowedLinkStyled = styled.a<{ uiSize: UI_SIZE }>`
  &&& {
    ${overlayLinkOrButtonStyle}
    ${textButtonStyle}
    ${shareButtonStyle}
    background-color: rgb(0 0 0 / 70%);
  }
`;

export const NotAllowedLinkVideo: FC = () => {
  const { useStoreState } = usePlayerStore();
  const programId = useStoreState.programId();
  const isSimulcast = useStoreState.isSimulcast();

  const { language } = useEmbedParametersContext();

  return (
    programId && (
      <OverlayButtonWrapper>
        <NotAllowedLinkStyled
          aria-label={i18n("linkki_yle_areenaan", { language })}
          href={getAreenaUrl({
            isSimulcast,
            language,
            programId
          })}
          uiSize={UI_SIZE.DEFAULT}>
          <span>{i18n("katso_yle_areenassa", { language })}</span>
          <ArrowRight color={darkTheme.ACTION_PRIMARY} />
        </NotAllowedLinkStyled>
      </OverlayButtonWrapper>
    )
  );
};
